function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import * as React from 'react';
import { levelsFormatter } from "./sections";
import Section from "./Section";
import SectionBuilder from "./SectionBuilder";
var SchoolsAttendedSection = function SchoolsAttendedSection(_ref) {
  var snapshot = _ref.snapshot,
    currentSnapshot = _ref.currentSnapshot,
    committedKeys = _ref.committedKeys,
    onCommit = _ref.onCommit;
  var snapshotSchoolsAttended = snapshot.programApplication.applicant.schoolsAttended;
  var currentSchoolsAttended = currentSnapshot.programApplication.applicant.schoolsAttended;
  var sectionKeys = React.useMemo(function () {
    var attendedSchoolIds = new Set();
    snapshotSchoolsAttended.forEach(function (school) {
      return attendedSchoolIds.add(school.id);
    });
    currentSchoolsAttended.forEach(function (school) {
      return attendedSchoolIds.add(school.id);
    });
    var keys = [];
    attendedSchoolIds.forEach(function (id) {
      keys.push(getAttendedSchoolKeys(id));
    });
    return keys;
  }, [snapshotSchoolsAttended, currentSchoolsAttended]);
  return /*#__PURE__*/React.createElement(Section, {
    title: "Schools Attended",
    columns: 1
  }, sectionKeys.map(function (keys, i) {
    return /*#__PURE__*/React.createElement(SectionBuilder, {
      key: i,
      snapshot: snapshot,
      currentSnapshot: currentSnapshot,
      committedKeys: committedKeys,
      onCommit: onCommit,
      sectionKeys: keys,
      columns: 3
    });
  }));
};
function getAttendedSchoolKeys(schoolId) {
  var _ref2;
  var BASE = "programApplication.applicant.schoolsAttended.{".concat(schoolId, "}");
  return _ref2 = {}, _defineProperty(_ref2, "".concat(BASE, ".schoolName"), {
    title: 'School Name'
  }), _defineProperty(_ref2, "".concat(BASE, ".level"), {
    title: 'Level',
    formatter: levelsFormatter
  }), _defineProperty(_ref2, "".concat(BASE, ".startDate"), {
    title: 'Start Date'
  }), _defineProperty(_ref2, "".concat(BASE, ".endDate"), {
    title: 'End Date'
  }), _defineProperty(_ref2, "".concat(BASE, ".degreeName"), {
    title: 'Degree Name'
  }), _defineProperty(_ref2, "".concat(BASE, ".dateDegreeAwarded"), {
    title: 'Date Degree Awarded'
  }), _defineProperty(_ref2, "".concat(BASE, ".language"), {
    title: 'Language'
  }), _ref2;
}
export default /*#__PURE__*/React.memo(SchoolsAttendedSection);